export default __webpack_public_path__ + "resources/icons/d140-8e18.webp";